import { post } from 'store/http/httpAction';

export const sendEmailToResetPassword = (email, resetUrl, cb) =>
  dispatch =>
    post('/admin/send_reset_password_link/email', { config__reset_password_url: resetUrl, email }, dispatch).then((data, statusCode) => {
      if (data && data.message && _.isFunction(cb)) {
        cb();
      }
    });

export const updateUserPassword = (email, password, confirmPassword, token, cb) =>
  dispatch =>
    post('/admin/reset_password', {
      email,
      password,
      password_confirmation: confirmPassword,
      token
    }, dispatch).then(data => {
      if (data && data.user_name && _.isFunction(cb)) {
        cb(data.user_name);
      }
    });



// WEBPACK FOOTER //
// ./src/views/Auth/flow/action.js